<template>
    <div class="body_img">
        <div id="main_regedit_div" class="regedit">
            <div class="input_area">
                <div class="title1">用户注册</div>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="USER_NAME">姓名:</label>
                <input type="text" class="big_txt1" id="USER_NAME" placeholder="个人姓名..." v-model="USER_NAME" />
                <span class="right_tip tip_error" id="tip_user_name">{{ tip_user_name }}</span>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="PHONE">手机号:</label>
                <input type="text" class="big_txt1" id="PHONE" placeholder="常用手机号..." v-model="PHONE" />
                <span class="right_tip" id="tip_phone">{{ tip_phone }}</span>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="LOGIN_NAME">登录名:</label>
                <input type="text" class="big_txt1" id="LOGIN_NAME" placeholder="数字和字母..." v-model="LOGIN_NAME" />
                <span class="right_tip" id="tip_login_name">{{ tip_login_name }}</span>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="LOGIN_PWD1">密码:</label>
                <input type="password" class="big_txt1" id="LOGIN_PWD1" placeholder="密码..." v-model="LOGIN_PWD1" />
                <span class="right_tip" id="tip_pwd1">{{ tip_pwd1 }}</span>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="LOGIN_PWD2">确认密码:</label>
                <input type="password" class="big_txt1" id="LOGIN_PWD2" placeholder="再次输入密码..." v-model="LOGIN_PWD2" />
                <span class="right_tip" id="tip_pwd2">{{ tip_pwd2 }}</span>
            </div>
            <div class="input_area">
                <label class="left_lbl" for="YZM">验证码:</label>
                <div id="left_YZM">
                    <input id="YZM" type="text" class="big_txt1" placeholder="验证码" v-model="YZM" />
                </div>
                <div id="left_YZMA" @click="RefreshYZM">
                    <a id="YZMA" href="javaScript:void(0);">
                        <img id="YZMImg" :src="YZMImg" />
                    </a>
                </div>
                <span class="right_tip" id="tip_YZM">{{ tip_YZM }}</span>
            </div>
            <div class="input_area">
                <button type="button" id="btn_regist" @click="toRegist">注册</button>
            </div>
            <div class="input_area">
                <span id="tip_regist">{{ tip_regist }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import gConfig from '../gConfig';
import GCommon from '../GCommon';

export default {
    name: 'regist',
    data() {
        return {
            USER_NAME: '',
            PHONE: '',
            LOGIN_NAME: '',
            LOGIN_PWD1: '',
            LOGIN_PWD2: '',
            YZM: '',
            YZMImg: gConfig.web_pc + '/home/IndexMain/GetCheckCode',
            tip_user_name: '',
            tip_phone: '',
            tip_login_name: '',
            tip_pwd1: '',
            tip_pwd2: '',
            tip_YZM: '',
            tip_regist: '',
            to_login: 0
        }
    },
    methods: {
        RefreshYZM() {
            var src1 = gConfig.web_pc + '/home/IndexMain/GetCheckCode?t=' + new Date().getMilliseconds();
            this.YZMImg = src1;
        },
        ClearTip() {
            this.tip_user_name = '';
            this.tip_phone = '';
            this.tip_login_name = '';
            this.tip_pwd1 = '';
            this.tip_pwd2 = '';
            this.tip_YZM = '';
            this.tip_regist = '';
        },
        CheckUser() {
            this.ClearTip();
            var name1 = this.USER_NAME;
            if (name1 == null || name1 == undefined || name1 == '') {
                this.tip_user_name = '姓名不能为空';
                return false;
            } else {
                this.tip_user_name = '';
                return true;
            }
        },
        CheckPhone() {
            this.ClearTip();
            var phone = this.PHONE;
            var isPhone = GCommon.CheckPhone(phone);
            if (!isPhone.flag) {
                this.tip_phone = isPhone.msg;
                return false;
            } else {
                this.tip_phone = '';
                return true;
            }
        },
        CheckLoginName() {
            this.ClearTip();
            var loginName = this.LOGIN_NAME;
            var islogin = new GCommon.CheckLoginName(loginName);
            if (!islogin.flag) {
                this.tip_login_name = islogin.msg;
                return false;
            } else {
                this.tip_login_name = '';
                return true;
            }
        },
        CheckPwd() {
            this.ClearTip();
            var pwd1 = this.LOGIN_PWD1;
            var pwd2 = this.LOGIN_PWD2;
            var isPwd1 = GCommon.CheckPwd(pwd1);
            this.tip_pwd1 = '';
            this.tip_pwd2 = '';
            if (!isPwd1.flag) {
                this.tip_pwd1 = isPwd1.msg;
                return false;
            }
            var isPwd2 = GCommon.CheckPwd(pwd2);
            if (!isPwd2.flag) {
                this.tip_pwd2 = isPwd2.msg;
                return false;
            }
            if (pwd2 != pwd1) {
                this.tip_pwd2 = '两次输入的密码不一致';
                return false;
            }
            return true;
        },
        toLogin() {
            this.to_login = 1;
            window.location = '/';
        },
        CheckYZM() {
            this.ClearTip();
            if (this.YZM == undefined || this.YZM == null || this.YZM == '') {
                this.tip_YZM = '请输入验证码';
                return false;
            } else if (this.YZM.length != 4) {
                this.tip_YZM = '验证码不正确';
                return false;
            }
            return true;
        },
        toRegist() {
            if (!this.CheckUser()) {
                return;
            }
            if (!this.CheckPhone()) {
                return;
            }
            if (!this.CheckLoginName()) {
                return;
            }
            if (!this.CheckPwd()) {
                return;
            }
            if (!this.CheckYZM()) {
                return;
            }
            const self = this;
            var params = new URLSearchParams();
            params.append('USER_NAME', self.USER_NAME);
            params.append('LOGIN_NAME', self.LOGIN_NAME);
            params.append('PHONE', self.PHONE);
            params.append('LOGIN_PWD', self.LOGIN_PWD1);
            params.append('CHECK_CODE', self.YZM);
            axios.post(gConfig.web_pc + '/home/IndexMain/registGo', params).then(function (response) {
                self.RefreshYZM();
                var data = response.data;
                var flag = data.flag;
                var msg = data.msg;
                if (flag) {
                    self.tip_regist = '注册成功，请重新登录';
                    alert('注册成功，请重新登录');
                    self.toLogin();
                } else {
                    self.tip_regist = msg;
                }
                self.RefreshYZM();
            }).catch(function (error) {
                self.RefreshYZM();
                console.log(error);
            });
        }
    }
}
</script>
<style>
@import '../assets/homeContent/regist.css';
</style>



// WEBPACK FOOTER //
// src/html/regist.vue